import Aos from "aos";

export default function initAos() {

  Aos.init({
    duration: 1000,
    once: true,
    offset: 100
  });


  // Better support for loading="lazy" attribute
  // https://github.com/michalsnik/aos/issues/407#issuecomment-590554166
  document.querySelectorAll('img').forEach((img) =>
    img.addEventListener('load', () => {
        Aos.refresh();
      }
    )
  );
}
